import { createAction } from '@reduxjs/toolkit';
import { CustomerAddress } from './types';

export const setNeedsToCheckCustomerAccountsShippingAddressDraft =
  createAction<CustomerAddress>(
    'shippingAddress/setNeedsToCheckCustomerAccountsShippingAddressDraft',
  );

export const setNeedsToValidateFieldsOfCustomerAccountAddressDraft =
  createAction<boolean>(
    'shippingAddress/setNeedsToValidateFieldsOfCustomerAccountAddressDraft',
  );
